// src/config/supabaseClient.jsx
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY;

export const supabase = createClient(supabaseUrl, supabaseKey);

// Teste de conexão
//console.log('Supabase URL:', supabaseUrl);
//console.log('Supabase Client criado com sucesso');